export {
  addEvent,
  getOwnerDocument,
  getOwnerWindow,
  isDocument,
  isShadowRoot
} from '../../../src/utils/domHelpers';
